import { render } from "./SliderView.vue?vue&type=template&id=6658d56c&scoped=true"
import script from "./SliderView.vue?vue&type=script&lang=js"
export * from "./SliderView.vue?vue&type=script&lang=js"

import "./SliderView.vue?vue&type=style&index=0&id=6658d56c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6658d56c"]])

export default __exports__